import { gql } from '@apollo/client';

export const GET_AI_POLICY_INFO = gql(/* GraphQL */ `
  query GetAiPolicyInfo {
    getAiPolicyInfo {
      currentVersion
      policyText
      userAcceptedVersion
    }
  }
`);
